import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'lib-screen-square',
    templateUrl: './screen-square.component.html',
    styleUrls: ['./screen-square.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScreenSquareComponent implements OnInit {
  @Input() url;
  @Input() point;
  @Input() imageSize;
  widthPhoto = 100;
  heightPhoto = 100;
  leftPhoto = 50;
  topPhoto = 50;
  constructor(private laptop: ElementRef<HTMLElement>) {}

  @HostListener('window:resize') resize() {
    this.calc();
  }

  ngOnInit() {
    this.calc();
  }

  calc() {
    const { height, width } = this.laptop.nativeElement.getBoundingClientRect();
    console.log('wysokość kontenera', height, 'szerokość kontenera', width);

    // square
    this.heightPhoto = height * 0.3 + 50;
    this.widthPhoto = height * 0.3;

    this.topPhoto = (height - this.heightPhoto) / 2 - this.heightPhoto / 100;
    this.leftPhoto = (width - this.widthPhoto) / 2;
    console.log(
      'wysokość zdjecia',
      this.heightPhoto,
      'szerokość zdjecia',
      this.widthPhoto,
    );
    console.log('top zdjecia', this.topPhoto, 'left zdjecia', this.leftPhoto);
  }
}
